import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import {LoginUser} from '../../actions/user.js';
import LoginForm from './loginform.js';
import TopNav from '../includes/TopNav';
import {Helmet} from "react-helmet";

class Login extends Component{
  constructor(props) {
    super(props);
    this.state = { 'loginFailed': false}
  }
  submit = (values) => {
    this.props.dispatch(
      LoginUser(values, (body) => {
        //console.log("checking body of return ", body);
        //console.log("logged in successfully! ", this.props.User);
        if(body.user){
          if(body.user.loggedin){
            this.setState({'loginFailed': false});
            if(body.user.role === "student"){
              this.props.history.push('/studentdashboard');
            }else if (body.user.role === "editor") {
              this.props.history.push('/editordashboard');
            }
            else if (body.user.role === "admin") {
              this.props.history.push('/admindashboard');
            }
          }
        } else {
          this.setState({'loginFailed': true});
        }
      })
    );
  }
  render() {
      return (
        <div>
        <Helmet>
          <title>Login to Your Account  | Proofreading Manuscripts</title>
          <meta name="description" content="Login to your account to view your edited papers."></meta>
        </Helmet>
        <TopNav />
          <section className="thankyou">
            <div>
                <LoginForm shouldShowGetStarted={true} onSubmit={this.submit} loginFailed={this.state.loginFailed} {...this.props} />
            </div>
          </section>
       </div>
    )
  }
}

export default connect(
  ({Paper, Modals, User})=>({Paper, Modals, User})
)(Login);



// WEBPACK FOOTER //
// ./src/components/steps/Login.js